// extracted by mini-css-extract-plugin
module.exports = {"MyMysteryBoxModal":"MyMysteryBoxModal_MyMysteryBoxModal__1RZf8"};